module.exports = __webpack_public_path__ + "img/gift4-01-c06-t2.0b865de3.png";